import { useContext } from 'react';

import { RevisionContext } from '../contexts/RevisionContext';
import type { ProjectDashboardRevision } from '../projectDashboardTypes';

/** @deprecated Use `useCurrentRevision` hook instead for components within the project dashboard. */
const useRevision = (): ProjectDashboardRevision => {
  const revision = useContext(RevisionContext);
  if (!revision) {
    throw new Error('useRevision must be used within a RevisionProvider');
  }
  return revision;
};

export default useRevision;
